import { Typography } from "@circle-react-uikit/Typography";

interface OptionsDropdownItemContentProps {
  listItemText?: string;
  text: string;
}

export const OptionsDropdownItemContent = ({
  text,
  listItemText,
}: OptionsDropdownItemContentProps) => (
  <Typography.LabelSm weight="medium">
    {listItemText || text}
  </Typography.LabelSm>
);
